import {FORM_ERROR, SubmissionErrors} from "final-form";
import logger from "~src/services/logger/LlsLogger";

/*
 * use to catch errors on submitting - not necessarily axios error responses
 */
export function getCatchSubmitAnyError(componentName: string, defaultErrorMessage: string) {
  return function catchSubmitAnyError(error: unknown): SubmissionErrors | Promise<SubmissionErrors> | void {
    let loggedError = new Error(defaultErrorMessage);
    let stack = componentName;
    if (error instanceof Error) {
      loggedError = error;
      if (error.stack) {
        stack = error.stack;
      }
    }

    logger.info(defaultErrorMessage, {
      error: loggedError,
      info: {
        componentStack: stack,
      },
    });
    return {
      [FORM_ERROR]: [loggedError.name, loggedError.message].join(': '),
    };
  };
}
